import {ModuleWithProviders, NgModule} from '@angular/core';
import { NgChitikaComponent } from './ng-chitika.component';
import {CommonModule} from '@angular/common';
import {CHITIKA_TOKEN, ChitikaConfig} from './chitika-config';

@NgModule({
  imports: [
  CommonModule
  ],
  declarations: [NgChitikaComponent],
  exports: [NgChitikaComponent]
})
export class NgChitikaModule {
  static forRoot(config: Partial<ChitikaConfig> = {}): ModuleWithProviders {
    return {
      ngModule: NgChitikaModule,
      providers: [{ provide: CHITIKA_TOKEN, useValue: config }],
    };
  }
}
